/** Spanish (US) locale for system-settings-ui. */
import type { SystemSettingsLocale } from './en'

export const systemSettingsEsUs = {
  systemSettings: {
    title: `Configuración del sistema`,
    tabs: {
      general: `General`,
      defaults: `Predeterminados`,
      recording: `Grabación de llamadas`,
    },
    common: {
      save: `Guardar cambios`,
      active: `Activo`,
      inactive: `Inactivo`,
      yes: `Sí`,
      no: `No`,
      loading: `Cargando...`,
      selectOption: `-- Seleccionar --`,
      none: `Ninguno`,
      unsavedChanges: `Cambios sin guardar`,
    },
    general: {
      title: `General`,
      defaultTimeZone: `Zona horaria predeterminada`,
      callParkTimeout: `Tiempo de espera de aparcamiento (segundos)`,
      callParkTimeoutHelp:
        'Tiempo en segundos que una llamada permanece estacionada antes de regresar. Mínimo 30 segundos, máximo 1800 segundos. Recomendado: 300.',
      callParkWarning: `¿Está seguro de que desea dejar a los llamantes en el aparcamiento durante {{minutes}} minutos?`,
      extensionsTitle: `Extensiones`,
      extensionDigits: `Dígitos de extensión`,
      enableIntercom: `Habilitar intercomunicador`,
      searchTimezone: 'Buscar zonas horarias...',
      noTimezonesFound: 'No se encontraron zonas horarias',
    },
    defaults: {
      voiceTitle: `Voz`,
      defaultAreaCode: `Código de área predeterminado`,
      areaCodeRange: `El código de área debe estar entre 200 y 998`,
      areaCodeDisallowed: `Este código de área no está permitido`,
      defaultCallerId: `Identificador de llamadas predeterminado`,
      faxTitle: `Fax`,
      defaultFaxNumber: `Número de fax predeterminado`,
      defaultVirtualFax: `Fax virtual predeterminado`,
      defaultVirtualFaxSearchPlaceholder: `Buscar extensiones de fax virtual...`,
      defaultVirtualFaxSearchAriaLabel: `Buscar extensiones de fax virtual por nombre o número`,
      defaultVirtualFaxNoMatches: `Ninguna extensión de fax virtual coincide con esa búsqueda.`,
      emergencyTitle: `Valores predeterminados de emergencia`,
      emergencyName: `Nombre de emergencia`,
      emergencyNumber: `Número de emergencia`,
      emergencyNumberHelp: `Este campo es de solo lectura y no se puede cambiar aquí.`,
      emergencyAlert: `Alerta de emergencia`,
      holdMusicTitle: `Música de espera`,
      holdMusicPlaylist: `Música de espera`,
      noPlaylists: `No hay listas de reproducción disponibles`,
      playlistNotPlayableSuffix: `(sin pistas de audio)`,
      playlistEmptyError: `La lista de reproducción de música de espera seleccionada no tiene pistas de audio. Agregue pistas o elija otra lista de reproducción.`,
    },
    recording: {
      title: `Grabación de llamadas`,
      enableInbound: `Habilitar grabación de llamadas entrantes`,
      enableOutbound: `Habilitar grabación de llamadas salientes`,
      enableInternal: `Habilitar grabación de llamadas internas`,
    },
    toast: {
      saveSuccess: `Configuración guardada correctamente`,
      saveError: `Error al guardar la configuración`,
      validationError: `No se puede guardar — por favor corrija los errores arriba`,
    },
    error: {
      loadFailed: `Error al cargar la configuración del sistema. Por favor, inténtelo de nuevo.`,
    },
  },
} satisfies SystemSettingsLocale
